"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Zap, Shield, TrendingUp } from "lucide-react";
export default function Features() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: Zap,
    title: "Lightning Fast",
    description: "Experience blazing-fast performance with our optimized infrastructure and cutting-edge technology stack.",
    link: "#"
  }, {
    icon: Shield,
    title: "Enterprise Security",
    description: "Bank-grade security measures protect your data with end-to-end encryption and advanced threat detection.",
    link: "#"
  }, {
    icon: TrendingUp,
    title: "Scalable Growth",
    description: "Seamlessly scale your operations as you grow, with flexible plans and unlimited potential for expansion.",
    link: "#"
  }];
  const refs = [ref1, ref2, ref3];
  const visibility = [isVisible1, isVisible2, isVisible3];
  return <section id="features" className="bg-surface py-24 md:py-32">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ${visibility[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] bg-background border border-border">
                  <CardContent className="flex flex-col items-start gap-4">
                    <div className="p-3 rounded-lg bg-primary-light">
                      <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                    </div>
                    <h3 className="text-[22px] font-semibold text-foreground">{feature.title}</h3>
                    <p className="text-[16px] leading-[1.6] text-muted-foreground">{feature.description}</p>
                    <Link to={feature.link} className="text-primary hover:text-accent-dark font-medium inline-flex items-center gap-2 mt-2 transition-colors duration-[var(--duration-fast)]">
                      Learn More
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}